module.exports = __webpack_public_path__ + "static/img/jq_video_img.4be1053.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jq/jq_video_img.png
// module id = wRK2
// module chunks = 1